import { DecimalPipe, PercentPipe } from '@angular/common';

import { AaCurrencyPipe } from '../pipes/aa-currency.pipe';
import { AaFinYearPipe } from '../pipes/aa-fin-year.pipe';
import { AaListDatePipe } from '../pipes/aa-list-date.pipe';
import { RegisterData, RegisterParams } from '../resolvers/register.resolver';
import { toUniversalDateString } from '../utils/date-utils';
import { TypedActivatedRoute } from '../utils/route-utils';
import { translateTransactionTypeName } from './transaction-type-translate';

export const EXCEL_DATE_CLASS = 'ExcelDate';
export const EXCEL_CURRENCY_CLASS = 'ExcelCurrency';
export const EXCEL_PERCENTAGE_CLASS = 'ExcelPercentage';

export const dateValueFormatter =
  (locale: string, route: TypedActivatedRoute<RegisterParams, RegisterData>) =>
  ({ node, value }): string =>
    node && node.group && node.expanded && !node.footer
      ? ''
      : (value != null && value !== '' && new AaListDatePipe(locale, route).transform(value)) || '';

export const decimalValueFormatter =
  (locale: string) =>
  ({ node, value }): string =>
    node && node.group && node.expanded && !node.footer
      ? ''
      : (value != null && value !== '' && new DecimalPipe(locale).transform(value, '1.0-2')) || '';

export const percentageValueFormatter =
  (locale: string) =>
  ({ node, value }): string =>
    node && node.group && node.expanded && !node.footer
      ? ''
      : (value != null && value !== '' && new PercentPipe(locale).transform(value, '1.2')) || '-';

export const currencyValueFormatter =
  (locale: string, route: TypedActivatedRoute<RegisterParams, RegisterData>) =>
  ({ value }): string =>
    (value !== '' && new AaCurrencyPipe(locale, route).transform(value)) || '-';

export const yesNoValueFormatter =
  () =>
  ({ value }): string => {
    if (value === null || value === undefined) {
      return '';
    }
    return value ? 'Yes' : 'No';
  };

export const finYearValueFormatter =
  (locale: string) =>
  ({ value }): string =>
    new AaFinYearPipe().transform(value) || '';

export const transactionTypeValueFormatter =
  () =>
  ({ value }) => {
    return translateTransactionTypeName({ eventType: value });
  };

export const getDateFilterParams = () => {
  return {
    filterOptions: [
      'equals',
      'notEqual',
      'lessThan',
      'lessThanOrEqual',
      'greaterThan',
      'greaterThanOrEqual',
      'inRange',
    ],
    // use inRangeInclusive: true for the range filter to include the selected
    // from and to dates. Setting it false would fetch only the in between dates
    inRangeInclusive: true,
    comparator(filterLocalDateAtMidnight, cellValue) {
      const cellDate = toUniversalDateString(cellValue);
      const filterDate = toUniversalDateString(filterLocalDateAtMidnight);
      if (!cellDate || !filterDate) {
        if (!cellDate && !filterDate) {
          return 0;
        }
        return !cellDate ? -1 : 1;
      }

      if (cellDate < filterLocalDateAtMidnight) {
        return -1;
      }

      if (cellDate > filterLocalDateAtMidnight) {
        return 1;
      }

      return 0;
    },
  };
};
